























































































import AbpBase from "@/lib/abpbase";
import { Component } from "vue-property-decorator";
import FollowPlanAdd from "./planAdd.vue";
import FollowPlanDetailAdd from "./planDetailAdd.vue";
import {
  QueryFollowPlanList,
  DeleteFollowPlan,
  QueryFollowPlanDetailList,
  DeleteFollowPlanDetail
} from "@/api/follow/followPlan";
@Component({
  components: {
    FollowPlanAdd,
    FollowPlanDetailAdd
  }
})
export default class FollowPlan extends AbpBase {
  split1 = 0.5;
  loading: boolean = false;
  detailLoading: boolean = false;
  currentPlan: any = {};
  currentPlanDetail: any = {};
  showPlan: boolean = false;
  showPlanDetail: boolean = false;
  response: any = {};
  detailResponse: any = {};
  payload = {
    QueryString: "",
    Page: 1,
    PageSize: 10
  };
  detailPayload = {
    Follow_Plan_ID: 0,
    QueryString: "",
    Page: 1,
    PageSize: 10
  };
  columns = [
    {
      title: "计划名称",
      key: "name",
      minWidth: 150
    },
    {
      title: "适用患者",
      key: "",
      minWidth: 180,
      render: (h: any, p: any) => {
        let sourceList: any = [];
        let sourceContent = "";
        if (p.row.followPlanSourceList) {
          p.row.followPlanSourceList.forEach((item: any) => {
            sourceList.push(item.typeName);
          });
          sourceContent = sourceList.join("、");
        }
        return h("span", {}, sourceContent);
      }
    },
    {
      title: "操作",
      key: "",
      minWidth: 130,
      render: (h: any, p: any) => {
        return h("div", [
          h("Button", {
            props: { type: "success", icon: "ios-create", size: "small" },
            style: { marginRight: "5px" },
            on: {
              click: () => {
                this.handleUpdatePlan(p.row);
              }
            }
          }),
          h("Button", {
            props: { type: "error", icon: "ios-trash", size: "small" },
            on: {
              click: () => {
                this.handleDeletePlan(p.row.id);
              }
            }
          })
        ]);
      }
    }
  ];
  detailColumns = [
    {
      title: "名称",
      key: "name",
      minWidth: 120
    },
    {
      title: "说明",
      key: "note",
      minWidth: 200
    },
    {
      title: "操作",
      key: "",
      minWidth: 150,
      render: (h: any, p: any) => {
        return h("div", [
          h("Button", {
            props: { type: "success", icon: "ios-create", size: "small" },
            style: { marginRight: "5px" },
            on: {
              click: () => {
                this.handleUpdatePlanDetail(p.row);
              }
            }
          }),
          h("Button", {
            props: { type: "error", icon: "ios-trash", size: "small" },
            on: {
              click: () => {
                this.handleDeletePlanDetail(p.row.id);
              }
            }
          })
        ]);
      }
    }
  ];

  handleUpdatePlan(row: any) {
    this.currentPlan = Object.assign({}, row);
    this.showPlan = true;
  }

  handleDeletePlan(id: number) {
    this.$confirm("确定要删除吗？", "提示").then(async () => {
      await DeleteFollowPlan(id);
      this.getPlanList();
      this.getPlanDetailList();
    });
  }

  handleAddPlan() {
    this.currentPlan = {
      id: 0,
      followPlanSourceList: []
    };
    this.showPlan = true;
  }

  handleUpdatePlanDetail(row: any) {
    this.currentPlanDetail = Object.assign({}, row);
    this.showPlanDetail = true;
  }

  handleDeletePlanDetail(id: number) {
    this.$confirm("确定要删除吗？", "提示").then(async () => {
      await DeleteFollowPlanDetail(id);
      this.getPlanDetailList();
    });
  }

  handleAddPlanDetail() {
    if (!this.currentPlan.id) {
      this.$Message.error("请选择一个随访计划");
      return;
    }

    this.currentPlanDetail = {
      id: 0,
      Follow_Plan_ID: this.currentPlan.id
    };
    this.showPlanDetail = true;
  }

  handlePlanPageChange(val: any) {
    this.payload.Page = val;
    this.getPlanList();
  }

  handlePlanDetailPageChange(val: any) {
    this.detailPayload.Page = val;
    this.getPlanDetailList();
  }

  handlePlanAddOk() {
    this.$refs.FollowPlanAdd.submit().then(res => {
      if (res) {
        this.showPlan = false;
        this.getPlanList();
      }
    });
  }

  handlePlanDetailAddOk() {
    this.$refs.FollowPlanDetailAdd.submit().then(res => {
      if (res) {
        this.showPlanDetail = false;
        this.getPlanDetailList();
      }
    });
  }

  handlePlanAddVisibleChange(res: any) {
    if (!res) {
      this.$refs.FollowPlanAdd.resetForm();
    }
  }

  handlePlanDetailAddVisibleChange(res: any) {
    if (!res) {
      this.$refs.FollowPlanDetailAdd.resetForm();
    }
  }

  handlePlanClick(row: any, index: any) {
    this.currentPlan = row;
    this.getPlanDetailList();
  }

  async getPlanList() {
    this.loading = true;
    let res = await QueryFollowPlanList(this.payload);
    this.response = res.data;
    this.loading = false;
  }

  async getPlanDetailList() {
    if (this.currentPlan.id) {
      this.detailLoading = true;
      this.detailPayload.Follow_Plan_ID = this.currentPlan.id;
      let res = await QueryFollowPlanDetailList(this.detailPayload);
      this.detailResponse = res.data;
      this.detailLoading = false;
    }
  }

  created() {
    this.getPlanList();
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/follow/followPlan/index.vue